export default __webpack_public_path__ + "static/media/icon_email.dc969eb4.svg";